import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: 200px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 32px;
  background: #fff;
  gap: 16px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 20px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: #f0fbfc; }
`;

export const SearchWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 380px;
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 0.9rem;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 9px 12px 9px 34px;
  border-radius: 20px;
  border: 1.5px solid #dce8f0;
  background: #f5f9fc;
  font-size: 0.85rem;
  color: #333;
  outline: none;
  box-sizing: border-box;

  &:focus { border-color: #26A9B6; background: #fff; }
`;

export const Content = styled.div`
  padding: 28px 32px;
`;

export const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 20px;
`;

/* ---- Table ---- */
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
`;

export const Thead = styled.thead``;

export const Th = styled.th`
  padding: 12px 14px;
  text-align: left;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #26A9B6;
  border-bottom: 1px solid #e8f2f7;
  white-space: nowrap;
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  border-bottom: 1px solid #f0f6fa;
  background: ${({ $selected }) => ($selected ? "#e8f8fa" : "transparent")};
  cursor: pointer;

  &:hover { background: #f5fbfc; }
  &:last-child { border-bottom: none; }
`;

export const Td = styled.td`
  padding: 11px 14px;
  font-size: 0.84rem;
  color: #333;
  vertical-align: middle;
`;

export const AvatarCell = styled.img`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
`;

export const EmptyRow = styled.tr`
  td {
    padding: 40px;
    text-align: center;
    color: #aaa;
    font-size: 0.9rem;
  }
`;

/* ---- Action icons ---- */
export const ActionCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const IconBtn = styled.button`
  position: relative;
  background: none;
  border: none;
  color: #8aa;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  font-size: 1rem;

  &:hover { color: #26A9B6; }
`;

export const NotifBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #e53e3e;
  color: #fff;
  font-size: 0.55rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;
